import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncFn } from "react-use";

interface ForkUnpinDialogProps {
  alias: string;
  open?: boolean;
  onOpen?: (open: boolean) => void;
}

const ForkUnpinDialog: FC<ForkUnpinDialogProps> = props => {
  const { alias, open, onOpen } = props;
  const navigate = useNavigate();
  const [{ error, loading }, submit] = useAsyncFn(async () => {
    await api.removePersistent(alias);
    // force reload page to reload forks list
    navigate("/");
  }, [alias, navigate]);

  return (
    <Dialog modal open={open} onOpenChange={onOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Unpin fork {alias}</DialogTitle>
          <DialogDescription>Please confirm the action</DialogDescription>
        </DialogHeader>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            variant="destructive"
            disabled={loading}
            onClick={submit}
            loading={loading}
          >
            Unpin fork
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ForkUnpinDialog;
